import { AbstractComponent } from "appworks/components/abstract-component";
import { ComponentFactory } from "appworks/components/factories/component-factory";
import { PaginationMode } from "appworks/components/ui/pagination-component";
import { Layers } from "appworks/graphics/layers/layers";
import { PaytableComponent } from "../paytable/paytable-component";

export interface PaytableComponentConfig {
    contentLayerName: string;
    uiLayerName: string;
    mode: PaginationMode;
    paytableLayerOrder: string;
    showTrailingDecimalsOnPayouts: boolean;
}

export class PaytableFactory implements ComponentFactory {

    protected config: PaytableComponentConfig = {
        contentLayerName: "PaytableContent",
        uiLayerName: "PaytableCommon",
        mode: PaginationMode.PAGIFY,
        paytableLayerOrder: "default",
        showTrailingDecimalsOnPayouts: false
    };

    constructor(config?: Partial<PaytableComponentConfig>) {

        if (config) {
            this.config = { ...this.config, ...config };
        }
    }

    public build(): AbstractComponent {
        return new PaytableComponent(
            Layers.get(this.config.contentLayerName),
            Layers.get(this.config.uiLayerName),
            this.config.mode,
            this.config.paytableLayerOrder,
            this.config.showTrailingDecimalsOnPayouts
        );
    }
}
